import ImgFromIdContainer from 'components/ImgFromId/ImgFromIdContainer'

export default {
  Container: ImgFromIdContainer,
}
